import { format, parse, parseISO } from 'date-fns'

export function useFormatDate() {
  const formatDate = value => {
    if (value) {
      const date =
        typeof value === 'string'
          ? parse(value, 'yyyy-MM-dd', new Date())
          : value
      return format(date, 'dd.MM.yyyy')
    }
    return value
  }

  const formatDateTime = value => {
    if (value) {
      const date = parseISO(value)
      return format(date, 'dd.MM.yyyy HH:mm:SS')
    }
    return value
  }

  const formatDatePickerToISO = value => {
    if (value) {
      return format(value, 'yyyy-MM-dd')
    }
    return value
  }

  const formatISOToDatePicker = value => {
    if (value) {
      if (value.endsWith('Z')) {
        return parse(value, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'", new Date())
      }
      return parse(value, 'yyyy-MM-dd', new Date())
    }
    return value
  }

  return {
    formatDate,
    formatDateTime,
    formatDatePickerToISO,
    formatISOToDatePicker,
  }
}
